import { combineReducers } from 'redux';
import { storeKey as tokenKey, reducer as tokenReducer } from './tokenDuck';

export { default as tokenDuck } from './tokenDuck';
export { jwtMiddleware } from './jwtMiddleware';
export { jwtListener } from './jwtListener';
export const jwtReducer = combineReducers({
  [tokenKey]: tokenReducer,
});
